import React, { useState } from "react";
import "./ServiceDetails.css";
import Widgets from "../../../../widgets";
import { useTranslation } from "react-i18next";
import Component from "../../..";
import strings from "../../../../utils/strings";

const ServiceDetails = ({ setSelectedView }) => {
  const { t } = useTranslation();
  const breadcrumbs = ["nursingCare", "manageRequests", "serviceDetails"];
  const paths = [strings.navigation.manageNurseReq, strings.navigation.manageNurseReq, strings.navigation.viewNurseReqDetails];
  const [steps] = useState([`patientDetails`, `${t("serviceDetails")}`, `${t("nursePref")}`, `${t("sendQuote")}`]);
  const [enabledSteps, setEnabledSteps] = useState([1]);
  const [currentStep, setCurrentStep] = useState(1);
  const [page, setPage] = useState(1);

  const handleStepChange = (stepIndex) => {
    setCurrentStep(stepIndex);
    setPage(stepIndex);
  };

  return (
    <div className="service-details-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading">{t("generateQuotation")}</div>
      <Widgets.ProgressBar steps={steps} currentStep={currentStep} enabledSteps={enabledSteps} onStepChange={handleStepChange} />
      {page === 1 && <Component.PatientDetails setPage={setPage} />}
    </div>
  );
};

export default ServiceDetails;
